import History from "@/history/History";

export default [
    {
        path: '/history',
        component: History
    },
];
